import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const BrunswickPage = () => <LocationTemplate suburbName="Brunswick" suburbSlug="brunswick" />;

export default BrunswickPage;
